import React from 'react'
import styled from 'styled-components'
import { Flex, Heading, Text, Link, Image,LinkExternal } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Container from 'components/Layout/Container'
import { useWeb3React } from '@web3-react/core'

// ************* tsuply price mcap burned  ****************
import { useTotalSupply, useBurnedBalance} from 'hooks/useTokenBalance'
import { getCakeAddress } from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber,formatNumber } from 'utils/formatBalance'
import { usePriceCakeBusd } from 'state/farms/hooks'
import Balance from 'components/Balance'
// ************* tsuply ****************

import SunburstSvg from './SunburstSvg'
import CompositeImage from './CompositeImage'

const BgWrapper = styled.div`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`

const StyledSunburst = styled(SunburstSvg)`
  height: 350%;
  width: 350%;

  ${({ theme }) => theme.mediaQueries.xl} {
    height: 400%;
    width: 400%;
  }
`

const Wrapper = styled(Flex)`
  z-index: 1;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`
const StyledImage = styled(Image)`
`






const Footer = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  
  // ************* tsuply price mcap burned   ****************
  const maxsupply = '20000000000'
  const totalSupply = useTotalSupply()
  const burnedBalance = getBalanceNumber(useBurnedBalance(getCakeAddress()))
  const cakeSupply = totalSupply ? getBalanceNumber(totalSupply) - burnedBalance : 0
  const cakePriceBusd = usePriceCakeBusd()
  const mcap = cakePriceBusd.times(maxsupply)
  // const mcap = cakePriceBusd.times(cakeSupply)
  const mcapString = formatNumber(mcap.toNumber())
  // ************* tsuply ****************

  return (        
    <>
	
	
{/*  <Wrapper className="logoslider Exchange">
<Text className="heding" mb="20px" bold color="black" size="20">
{t('Exchanges')}
</Text>
<Text mb="24px" className="logodiv">
<a href="/swap?outputCurrency=0x19857937848c02afbde8b526610f0f2f89e9960d">	
<StyledImage className="plogo" src="/images/decorations/exchange1.png" alt="AmpleSwap" width={170} height={50} />
</a>

<LinkExternal href="https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x19857937848C02AfbdE8B526610f0F2F89e9960d">
<StyledImage className="plogo" src="/images/decorations/exchange2.png" alt="PancakeSwap" width={190} height={50} />
</LinkExternal>

<LinkExternal href="https://babydogeswap.com/swap">
<StyledImage className="plogo" src="/images/decorations/exchange3.png" alt="BabyDogeSwap" width={230} height={50} />
</LinkExternal> 
</Text>
</Wrapper>   */}
	
	{/*
	<Wrapper className="logoslider">
	
	<Text className="heding" mb="20px" bold color="black" size="20">
          {t('AmpleSwap Partners')}
    </Text>
	
	<Text mb="24px" className="logodiv">
	<StyledImage className="plogo" src="/images/decorations/logo-1.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-2.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-3.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-4.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-5.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-6.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-7.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-8.png" alt="AmpleSwap" width={162} height={70} />
	<StyledImage className="plogo" src="/images/decorations/logo-9.png" alt="AmpleSwap" width={162} height={70} />
	</Text>
	</Wrapper>
	 */}
	
	

      <BgWrapper>
        <Flex alignItems="center" className="mainfooter" justifyContent="center" width="100%" height="100%">
          <StyledSunburst />
        </Flex>
      </BgWrapper>
	  

      <Wrapper className="mainfooter">
        
       
        <Text mb="15px" bold color="white" className="footer footerbox">
		
		
		<Text mb="15px" bold color="white" className="leftbox">
			<Text mb="15px" bold color="white" className="topbox box1">
			<StyledImage className="ampleicon" src="/images/decorations/ampleicon.png" alt="AmpleSwap" width={33} height={30} /> {t('Ample')}
			<Text mb="15px" bold color="white" className="token">
			{t('$')} {cakePriceBusd.toFixed(8)}
			</Text>
			</Text>
			<Text mb="24px" className="buybtnmain">
			<StyledImage src="/images/decorations/metmaskicon.png" alt="AmpleSwap" width={31} height={30} />
			<a className="butbtn" href="/swap?outputCurrency=0x19857937848c02afbde8b526610f0f2f89e9960d">Buy</a>
		    </Text>
		</Text>
		
		
		
		
		<Text mb="15px" bold color="white" className="boxleft rightbox">
		
		<Text mb="15px" bold color="white" className="box1">
          {t('Max supply :')} 
		  <Text mb="15px" bold color="white" className="max">
		  {t ('20,000,000,000')}
		  </Text>
        </Text>
		
		<Text mb="15px" bold color="white" className="box">
          {t('Total supply :')} <Balance decimals={0}  value={cakeSupply} />
        </Text>
		<Text mb="15px" bold color="white" className="box">
          {t('Circulating supply :')} <Balance decimals={0}  value={cakeSupply} />
        </Text>
		<Text mb="15px" bold color="white" className="box">
          {t('Total Burned :')} <Balance decimals={0}  value={burnedBalance} />
        </Text>
		<Text mb="15px" bold color="white" className="box">
          {t('F.D. Market Cap :')} 
		  <Text mb="15px" bold color="white" className="max">
		  ${mcapString}
		  </Text>
        </Text>
		
		
		
		
		
		
        </Text>
    </Text>
		
		
		
		
		
		
		<Text mb="24px"  color="#1fc7d4" className="footer mobile">
		<Text mb="15px" bold color="white">
          {t('Products')}
        </Text>
		<a href="/swap?outputCurrency=0x19857937848c02afbde8b526610f0f2f89e9960d">Exchange</a> 
		<a href="/farms">Farms</a> 
		<a href="/pools">Pools</a>  
		<LinkExternal external  href="https://perp.ampleswap.com/" >Perpetual</LinkExternal> 
		<LinkExternal external  href="https://info.ampleswap.com/" >Analytics</LinkExternal> 
        </Text>
		
		
		<Text mb="24px"  color="#1fc7d4" className="footer mobile">
		<Text mb="15px" bold color="white">
          {t('About')}
        </Text>
		<LinkExternal external href="https://docs.ampleswap.com/contact-us">Contact Us</LinkExternal>
		<LinkExternal external href="https://docs.ampleswap.com">Docs</LinkExternal>
		<LinkExternal external href="https://ampleswap.medium.com">Blog</LinkExternal> 
		<LinkExternal external href="https://docs.ampleswap.com/media.html">Media</LinkExternal> 
		<LinkExternal external href="https://docs.ampleswap.com/partnerships">Partners</LinkExternal> 
        </Text>
		
		
		<Text mb="24px"  color="#1fc7d4" className="footer mobile">
		<Text mb="15px" bold color="white">
          {t('Services')}
        </Text>
        <LinkExternal external href="https://docs.ampleswap.com/ample">Ample Token</LinkExternal> 
        <LinkExternal external href="https://docs.ampleswap.com/business-partnerships">Apply to Launch</LinkExternal> 
        <LinkExternal external href="https://docs.ampleswap.com/ambassador-program">Ambassador Program</LinkExternal> 
        <LinkExternal external href="https://docs.ampleswap.com/roadmap">Roadmap</LinkExternal> 		
        </Text>
		
		
		<Text mb="24px"  color="#1fc7d4" className="footer mobilelast">
		<Text mb="15px" bold color="white">
          {t('Community')}
        </Text>
		<LinkExternal external className="telegram" href="https://t.me/ampleswap">&nbsp;</LinkExternal> 
		<LinkExternal external className="twitter" href="https://twitter.com/ampleswap">&nbsp;</LinkExternal> 
		<LinkExternal external className="medium" href="https://ampleswap.medium.com/">&nbsp;</LinkExternal> 
		</Text>
		

    
      </Wrapper>
    </>
  )
}






export default Footer